import { articles } from '../data/articles';

export function getArticle(slug) {
  return articles.find((article) => article.slug === slug);
}

export function filterArticles({ category = '', query = '' } = {}) {
  const normalizedQuery = query.trim().toLowerCase();
  return articles.filter((article) => {
    const inCategory = !category || article.category === category;
    const searchable = `${article.title} ${article.excerpt} ${article.category} ${article.author}`.toLowerCase();
    return inCategory && (!normalizedQuery || searchable.includes(normalizedQuery));
  });
}

export function getRelatedArticles(article) {
  const related = (article.relatedSlugs || []).map(getArticle).filter(Boolean);
  return related.length ? related : articles.filter((item) => item.slug !== article.slug).slice(0, 3);
}